import { ReportableGeoEventType } from 'features/geoEvents/geoEvent.types';
import { Report, ReportPhoto } from 'features/reports/report.types';

type ReportPathInput = {
  geoEventType: ReportableGeoEventType;
  geoEventId: number;
  reportId: number;
};

export const geoEventTypeToViewPrefix: Record<ReportableGeoEventType, string> =
  {
    wildfire: '/i',
    flooding: '/i',
    hazard: '/i',
  };

export const getGeoEventDetailPath = (
  geoEventType: ReportableGeoEventType,
  geoEventId: number,
): string => {
  const viewPrefix = geoEventTypeToViewPrefix[geoEventType];
  return `${viewPrefix}/${geoEventId}`;
};

export const getReportDetailPath = (input: ReportPathInput): string => {
  const { geoEventType, geoEventId, reportId } = input;
  const viewPrefix = geoEventTypeToViewPrefix[geoEventType];
  return `${viewPrefix}/${geoEventId}/reports/${reportId}`;
};

const geoEventTypeToEditPathPrefix: Record<ReportableGeoEventType, string> = {
  wildfire: 'incident',
  flooding: 'incident',
  hazard: 'incident',
};

export const getReportEditPath = (input: ReportPathInput): string => {
  const { geoEventType, geoEventId, reportId } = input;
  const editPathPrefix = geoEventTypeToEditPathPrefix[geoEventType];
  return `/${editPathPrefix}/${geoEventId}/reports/${reportId}/edit`;
};

export const isRingReport = (report: Report | ReportPhoto): boolean =>
  Boolean(report?.ringDeviceId);
